// SM2. Подписи вкладки «Подключения → Журналы S3» из ответа GET /api/journal-s3/connections.
// probe: { kind: 'midori' | 'kraken' | 'unreachable', version, error, export: { supported, configured, enabled,
// secret_set, installation_name, machine_matches, last_uploaded_day, last_error } }.

export const serverLabel = (probe) => {
  if (!probe) return 'нет ответа';
  if (probe.kind === 'kraken') return 'Kraken';
  if (probe.kind === 'midori') return probe.version ? `Midori ${probe.version}` : 'Midori';
  return probe.error ? `нет ответа: ${probe.error}` : 'нет ответа';
};

// tone: ok — выгрузка идёт; warn — включена, но что-то не так; off — выключена или не настроена; none — нечего включать.
export const exportStatus = (probe) => {
  if (!probe || probe.kind !== 'midori') return { text: '—', tone: 'none' };
  const exp = probe.export;
  if (!exp) return { text: probe.error || 'нет ответа', tone: 'warn' };
  if (!exp.supported) return { text: 'нет выгрузки в этой версии — нужна 0.9.76+', tone: 'none' };
  if (!exp.configured) return { text: 'не настроена', tone: 'off' };
  if (!exp.enabled) return { text: 'выключена', tone: 'off' };
  const parts = [`включена · папка ${exp.installation_name || '—'}`];
  parts.push(exp.last_uploaded_day ? `последние сутки ${exp.last_uploaded_day}` : 'суток в бакете ещё нет');
  if (exp.machine_matches === false) return { text: `${parts.join(' · ')} · база с другой машины — выгрузка стоит`, tone: 'warn' };
  if (exp.last_error) return { text: `${parts.join(' · ')} · ошибка: ${exp.last_error}`, tone: 'warn' };
  return { text: parts.join(' · '), tone: 'ok' };
};

export const canEnable = (probe) => Boolean(probe?.kind === 'midori' && probe.export?.supported);

export const canCheck = (probe) => Boolean(canEnable(probe) && probe.export?.configured);

const BOUND_BY = { api: 'по UUID сервера', reinstall: 'прежняя установка', manual: 'вручную' };

export const installationLabel = (item) => {
  const days = item.days_count
    ? `${item.days_count} сут. · ${item.first_day}${item.last_day !== item.first_day ? ` — ${item.last_day}` : ''}`
    : 'суток нет';
  const how = BOUND_BY[item.bound_by] ? ` · ${BOUND_BY[item.bound_by]}` : '';
  return `${item.installation_name} / ${String(item.installation_uuid).slice(0, 8)} · ${days}${how}`;
};
